import { combineReducers } from 'redux';
import getApiReducer from '../common/utils/getApiReducer';
import { SUBMIT_FILE } from './file-actions';

const reducers = combineReducers({
  newFile: getApiReducer(SUBMIT_FILE),
});

export default reducers;
